<ideal-product-vendor-link vendor-link [productId]="id()" *renderInItemResult="LayoutTargets.Title; id: 'vendor-link'; priority: -1" />
<ideal-product-id-label product-id [productId]="id()" *renderInItemResult="LayoutTargets.Title; id: 'product-id'; priority: -1" />
<ideal-product-short-description
  description
  [productId]="id()"
  *renderInItemResult="LayoutTargets.Title; id: 'short-description'; priority: -1"
/>

<ideal-product-not-returnable
  not-returnable
  [productId]="id()"
  *renderInItemResult="LayoutTargets.ImportantInfo; id: 'not-returnable'; priority: -1"
></ideal-product-not-returnable>

<ideal-item-stock-button [itemId]="id()" *renderInItemResult="LayoutTargets.Stock; id: 'stock-btn'; priority: -1" />

<ideal-item-price
  [itemId]="id()"
  sizing="fixed"
  disableCallForPrice="true"
  usePricePer="sold-in+container"
  layout="horizontal"
  *renderInItemResult="LayoutTargets.Price; id: 'price'; priority: -1"
></ideal-item-price>
